import { useState } from 'react'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

interface OfferUnavailableModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
}

export function OfferUnavailableModal({ open, setOpen, onConfirm }: OfferUnavailableModalProps) {
	return (
		<ConfirmationModal
			open={open}
			setOpen={setOpen}
			title="Offer Unavailable"
			onConfirm={onConfirm}
			confirmLabel="OK"
			hideCloseButton={true}
		>
			<p className="text-primary-text">
				This offer has expired or is no longer available, so this invite link can&apos;t be used.
			</p>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface OfferUnavailableModalManagedProps {
	onConfirm: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'offer-unavailable': OfferUnavailableModalManagedProps
	}
}

export function ManagedOfferUnavailableModal({
	onClose,
	onConfirm,
}: OfferUnavailableModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<OfferUnavailableModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
		/>
	)
}
